// Module
var code = "<component-loading data-bind=\"visible: isLoadingGpsSpeedData\"></component-loading>\r\n<div data-bind=\"if: highchartsOptions() && !isLoadingGpsSpeedData()\">\r\n    <div data-bind=\"highcharts: {options: highchartsOptions, chart: chart}, event: { mousedown: mousedown }\" class=\"chart voyage\"></div>\r\n</div>";
// Exports
module.exports = code;